import React, { useState } from 'react'
import styles from './compare.module.css'
import { useAppDispatch, useAppSelector } from '../../hooks/redux'
import { backURL } from '../../consts'
import { IoIosClose } from 'react-icons/io'
import { removeCompareProduct, removeAllProducts } from '../../features/compare/compareSlice'
import CompareModal from '../CompareModal/CompareModal'
import { useTranslation } from 'react-i18next'

const Compare = () => {
    const dispatch = useAppDispatch()
    const { products } = useAppSelector((state) => state.compare)
    const [open, setOpen] = useState(false)
    const { t } = useTranslation()

    return (
        <div className={styles.compare_container}>
            <div className={styles.reserve_item}></div>
            <div className={styles.compare_item}>
                {products?.[0] && (
                    <>
                        <img
                            src={
                                products?.[0]?.img?.startsWith('http')
                                    ? products?.[0]?.img
                                    : `${backURL}/${products?.[0]?.img}`
                            }
                            alt=""
                        />
                        <IoIosClose
                            onClick={() =>
                                dispatch(
                                    removeCompareProduct({
                                        product_id: products?.[0]?.product_id,
                                    })
                                )
                            }
                            className={styles.close_compare}
                        />
                    </>
                )}
            </div>
            <div className={styles.compare_item}>
                {products?.[1] && (
                    <>
                        <img
                            src={
                                products?.[1]?.img?.startsWith('http')
                                    ? products?.[1]?.img
                                    : `${backURL}/${products?.[1]?.img}`
                            }
                            alt=""
                        />
                        <IoIosClose
                            onClick={() =>
                                dispatch(
                                    removeCompareProduct({
                                        product_id: products?.[1]?.product_id,
                                    })
                                )
                            }
                            className={styles.close_compare}
                        />
                    </>
                )}
            </div>
            <div className={styles.compare_item}>
                {products?.[2] && (
                    <>
                        <img
                            src={
                                products?.[2]?.img?.startsWith('http')
                                    ? products?.[2]?.img
                                    : `${backURL}/${products?.[2]?.img}`
                            }
                            alt=""
                        />
                        <IoIosClose
                            onClick={() =>
                                dispatch(
                                    removeCompareProduct({
                                        product_id: products?.[2]?.product_id,
                                    })
                                )
                            }
                            className={styles.close_compare}
                        />
                    </>
                )}
            </div>
            <div className={styles.compare_item}>
                {products?.[3] && (
                    <>
                        <img
                            src={
                                products?.[3]?.img?.startsWith('http')
                                    ? products?.[3]?.img
                                    : `${backURL}/${products?.[3]?.img}`
                            }
                            alt=""
                        />
                        <IoIosClose
                            onClick={() =>
                                dispatch(
                                    removeCompareProduct({
                                        product_id: products?.[3]?.product_id,
                                    })
                                )
                            }
                            className={styles.close_compare}
                        />
                    </>
                )}
            </div>
            <div className={styles.compare_actions}>
                <button className={styles.clear_btn} onClick={() => dispatch(removeAllProducts())}>{t('compare.clear_all')}</button>
                <p>{t('compare.up_to_4')}</p>
                <button className={styles.compare_btn} onClick={() => setOpen(true)}>{t('compare.compare')}</button>
            </div>

            <CompareModal open={open} onClose={() => setOpen(false)} />
        </div>
    )
}

export default Compare
